import {
  ValidationProvider,
  ValidationObserver,
  setInteractionMode,
  extend,
} from 'vee-validate';
import {
  required,
  email,
  length,
  between,
  alpha_spaces,
  regex,
  min,
  max,
  alpha_num,
  confirmed,
} from 'vee-validate/dist/rules';
import { validate as validateCPF } from 'gerador-validador-cpf';
import VeeValidateLocalePT_BR from 'vee-validate/dist/locale/pt_BR.json';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} é obrigatório',
  computesRequired: true,
});

extend('confirmed', {
  ...confirmed,
  message: 'O campo de {_field_} deve ser igual ao campo de Senha',
  computesRequired: true,
});

extend('CPF', {
  validate: (value) => validateCPF(value),
  message: 'O CPF informado não é válido',
  computesRequired: true,
});

extend('cantBeCPF', {
  validate: (value) => !validateCPF(value),
  message: 'Documento não pode ser um CPF',
  computesRequired: true,
});

extend('space', {
  validate: (value) => /\s/.test(value),
  message: 'Informe nome e sobrenome',
  computesRequired: true,
});

extend('date', {
  validate: (value) => /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/.test(value),
  message: 'Informe uma data válida',
  computesRequired: true,
});

extend('alert_min', {
  validate: (value) => parseFloat(value) >= 0.01,
  message: 'Preencha com um valor válido',
  computesRequired: true,
});

extend('max_amount', {
  params: ['max'],
  validate: (value, { max }) => {
    const numericValue = parseFloat(value);
    const numericMax = parseFloat(max);
    return numericValue <= numericMax;
  },
  message: (field, { max }) => {
    const formattedMax = parseFloat(max).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return `O valor não pode ser maior que ${formattedMax}`;
  },
  computesRequired: true,
});

const rules = [
  { name: 'email', validator: email },
  { name: 'length', validator: length },
  { name: 'between', validator: between },
  { name: 'alpha', validator: alpha_spaces },
  { name: 'regex', validator: regex },
  { name: 'min', validator: min },
  { name: 'max', validator: max },
  { name: 'alpha_num', validator: alpha_num },
];
for (const rule of rules) {
  extend(rule.name, {
    ...rule.validator,
    message: VeeValidateLocalePT_BR.messages[rule.name],
  });
}

export {
  ValidationProvider,
  ValidationObserver,
};
